module.exports = __webpack_public_path__ + "static/kamel-boubakeur-28891f5f87b8a65a37eb49049eb5f645.jpg";